import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { Icons, IconsTypes } from '@/components/shared/Icons';
import { COMMON_LOCALE_PART } from '@/locale';
import { ITicket } from '@/types';

interface TickerProps {
  ticket: ITicket;
}

export const Ticket: FC<TickerProps> = ({ ticket }) => {
  const { t } = useTranslation(COMMON_LOCALE_PART);
  const { is_highlighted, price, description, is_active } = ticket;

  if (!is_active) return null;

  return (
    <div className="relative z-[1] self-stretch	flex w-[158px] flex-col items-center rounded-lg bg-white shadow-md">
      <div className="mb-3 mt-5 flex justify-center">
        {Icons({
          name: IconsTypes.TICKET,
          iconProps: {
            isHighlighted: is_highlighted,
          },
        })}
      </div>

      <h2 className="text-center text-[32px] font-bold">
        {price} {t('plan-visit.price-label')}
      </h2>
      <div className="my-5 relative w-full">
        {Icons({
          iconProps: {className: 'mx-auto'},
          name: IconsTypes.DASHED_DIVIDER,
        })}
        <div className="absolute -left-[15px] top-1/2 z-10 h-[30px] w-[30px] -translate-y-1/2 rounded-full bg-gray-700" />
        <div className="absolute -right-[15px] top-1/2 z-10 h-[30px] w-[30px] -translate-y-1/2  rounded-full bg-gray-700" />
      </div>
      <div className="pt-3 pb-6 px-6 text-center">
        <p className="text-[18px] font-bold">{description}</p>
      </div>
    </div>
  );
};
